import { useNavigate } from 'react-router-dom';
import { convertNameToPath } from '../../helper';

interface Props {
  label: string;
  path: string;
  id: string;
  isNotIncludeLabelInThePath?: boolean;
  state?: any;
}

const PageLink = ({
  label,
  path,
  id,
  isNotIncludeLabelInThePath = false,
  state,
}: Props) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(
      `${path}${!isNotIncludeLabelInThePath ? '/' + convertNameToPath(label) : ''}`,
      { state: { ...state, id } }
    );
  };

  return (
    <div onClick={handleClick} className="cursor-pointer hover:text-[#69b1ff]">
      {label}
    </div>
  );
};

export default PageLink;
